__turbopack_context__.v({
  "amount": "_4uNd4G_amount",
  "badge": "_4uNd4G_badge",
  "borderGlow": "_4uNd4G_borderGlow",
  "card": "_4uNd4G_card",
  "container": "_4uNd4G_container",
  "content": "_4uNd4G_content",
  "ctaButton": "_4uNd4G_ctaButton",
  "ctaContent": "_4uNd4G_ctaContent",
  "ctaLink": "_4uNd4G_ctaLink",
  "currency": "_4uNd4G_currency",
  "description": "_4uNd4G_description",
  "dismissButton": "_4uNd4G_dismissButton",
  "glowEffect": "_4uNd4G_glowEffect",
  "glowPulse": "_4uNd4G_glowPulse",
  "modal": "_4uNd4G_modal",
  "modalClose": "_4uNd4G_modalClose",
  "modalError": "_4uNd4G_modalError",
  "modalForm": "_4uNd4G_modalForm",
  "modalHeader": "_4uNd4G_modalHeader",
  "modalIcon": "_4uNd4G_modalIcon",
  "modalInput": "_4uNd4G_modalInput",
  "modalOverlay": "_4uNd4G_modalOverlay",
  "modalSubtitle": "_4uNd4G_modalSubtitle",
  "modalTerms": "_4uNd4G_modalTerms",
  "modalTitle": "_4uNd4G_modalTitle",
  "price": "_4uNd4G_price",
  "priceBlock": "_4uNd4G_priceBlock",
  "priceLabel": "_4uNd4G_priceLabel",
  "priceNote": "_4uNd4G_priceNote",
  "rotateBorder": "_4uNd4G_rotateBorder",
  "sparkle": "_4uNd4G_sparkle",
  "spin": "_4uNd4G_spin",
  "spinner": "_4uNd4G_spinner",
  "textContent": "_4uNd4G_textContent",
  "title": "_4uNd4G_title",
  "trustBar": "_4uNd4G_trustBar",
  "trustDivider": "_4uNd4G_trustDivider",
  "trustItem": "_4uNd4G_trustItem",
  "visible": "_4uNd4G_visible",
});
